import { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import ShowDoneIconOnSelect from '../../../../../../../icons/ShowDoneIconOnSelect';

export default function PlatformFeesPayable() {
    const [selected, setSelected] = useState();

    return (
        <ToggleButtonGroup
            color="main"
            value={selected}
            exclusive
            onChange={(event, newSelected) => setSelected(newSelected)}
            aria-label="Platform fees payable by"
        >
            <ToggleButton value={false}>
                Me
                {selected === false && <ShowDoneIconOnSelect />}
            </ToggleButton>
            <ToggleButton value={true}>
                Buyer
                {selected === true && <ShowDoneIconOnSelect />}
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
